<template>
  <v-menu :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on }">
      <b-btn :size="size" v-on="on" />
    </template>

    <v-list>
      <v-list-item class="w-header-picker__header">Tabellenspalten</v-list-item>
      <v-list-item v-for="(header, index) in headers" :key="index">
        <b-check-box :input-value="!header.hide" @change="setHeaderVisibility(header, $event)" />
        {{ header.text }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  model: { prop: 'headers' },
  props: {
    headers: { type: Array, required: true },
    size: { type: String }
  },
  methods: {
    setHeaderVisibility(header, visible) {
      this.$emit(
        'input',
        this.headers.map(_header =>
          _header.value != header.value
            ? _header
            : { ...header, hide: !visible }
        )
      );
    }
  }
};
</script>

<style lang="scss">
</style>